import * as React from "react";
import {
  Animator,
  batch,
  MoveIn,
  ScrollContainer,
  ScrollPage,
  ZoomIn,
} from "react-scroll-motion";
// import { useIsVisible } from "react-is-visible";

import {
  Avatar,
  Box,
  Center,
  Flex,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";

const SHIFT_AMOUNT = 200;

const messages = [
  "intro",
  {
    message: `To my favorite trenchcoated raccoons--
Thank you for being such a warm, welcoming weirdo and for making me feel right at home. You bring such a balance of expertise and growth, professionalism and humanity. Obviously I will miss Frankie Tony the most, but you're definitely also up there being missed. I am sending many hugs and other well wishes for the new position. THEY BETTER KNOW HOW GOOD THEY HAVE IT. ❤️ 
With love, 
`,
    author: "V",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/64d10030a43914584a7c3b3d_Victoria%20Wheeler.png",
    image: "/img/victoria-boston.png",
  },
  {
    message: `I digged through my photos and found this slightly blurry snapshot from one night at BBCon in Denver, which was my visit to the US where I first met Boston in person. I remember being so impressed by Boston being all chill and funny and joking around and once we hit the conference floor and he had his suit on, it was immediate laser focus and sky high presence, making sure not only he himself maxxed out conversations with booth visitors, but nudging everyone on the team to be diligent. And then, once the day was over, going right back into chill mode in this random bar backyard and just having a good time. 
    This is how I think of Boston, as an incredibly friendly and incredibly professional person at the same time, and knowing exactly how to switch between these things seamlessly. I know "work hard, play hard" is such a cliche, but it seems to me Boston falls into that category, in the best possible way.`,
    author: "Markus",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/64d1001b4065919de3b3c92c_Markus.png",
    image: "/img/markus-boston.png",
  },
  {
    message: `
    Hey Boston, 
    It's been great to work with you the past year and a half. I've learnt so much. Best of luck with GiveWell, I'm so excited for your new role as Chief Product Spy. I'm so glad I got to spend so much time with Bethany and Frankie (and even the cats! XD) at Clipper.`,
    author: "Buffy",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/64d1004643be782cd3592f4c_Vaidehi%20Agarwalla.png",
    image: "/img/vaidehi-boston.png",
  },
  {
    message: `
      Boston! 
      Hate to watch you go but I'm so excited for you as you take on this new chapter in your career. Givewell is getting a great one. Thanks so much for being so welcoming to me from the jump -- we're all rooting for you!
      Thanks so much!
    `,
    author: "Coop",
    avatar: "/avatar/coopavatar.png",
    image: "/img/coop-boston.png",
  },
  {
    message: `
    Hi Boston,
    Although working under your leadership was short, it was incredibly impactful. I’m so grateful for your kindness, brilliance, and being a role model you have been for me. Your ability to create a relaxed and open environment has made every conversation enjoyable and enriching and your guidance has instilled in me the values of professionalism and dedication. You embody the belief that "Leadership is not about being in charge. It is about taking care of those in your charge." I hope to join you for hikes on some of the beautiful volcanoes here or anywhere in the future. Exploring nature would be a wonderful way to continue learning from your adventurous spirit. Thank you so much once again for everything. 
    Wishing you all the best in your future endeavors!`,
    author: "Gilbert",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/6578e21a243cf97984b94b85_Property%201%3DHeadshots%2C%20Property%202%3DOur%20Team%2C%20Property%203%3DGilbert%20Alelojo%402x.png",
    image: "/img/gilbert-boston.png",
  },
  {
    message: `Boston,
    I will miss working with you and hope you will still be around some in coworking so you can continue to try to trick me into believing Nick has a cybertruck. I will forever appreciate that you reviewed 10000 resumes to pick mine out so I would get the opportunity to work with you, however brief! 
    Best of luck at the new job and hopefully I'll still get to see you around!`,
    author: "Tavish",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/6670eaee0893c1b45304fcee_tvGroup%2010495-p-500.png",
    image: "/img/tavish-boston.png",
  },
  {
    message: `
    Boston! 
    I'm so glad that weird VA company matched me with you and Nick. It's been quite the interesting journey and I've been so grateful for you guidance as I've transitioned back into the tech startup world. You've genuinely been the best boss, showing so much patience and an overwhelming willingness to teach and support. 
    Thank you for all the hard work and hours you've invested into Momentum over the past couple years. And for topping it all off with them most random, weirdo humor ever. It's been a blast working with you and I'm sad but so excited for you and your new adventure! 
    GiveWell is very lucky to have you!
    `,
    author: "Andrea",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/64d1000a7b8b240b3f65e649_Andrea.png",
    image: "/img/andrea-boston.png",
  },
  {
    message: `I'll keep it short, because I know how you feel about compliments. You've been a huge inspiration to me, both professionally and personally. Thank you for all your guidance. I'll miss the laughs, the beats, and the calm confidence that accompanies everything you do.
I'd say best of luck, but you don't need luck, your raw talent is more than sufficient. Keep in touch 💛`,
    author: "Dom",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/66102963808b0b0a2b6db10a_Group%209960-p-500.png",
    image: "/img/dom-boston.png",
  },
  {
    message: `I won't try to express it all here:
    I've loved this part of the journey so much and am so happy to be going through life with you! 
    I can't wait for this next chapter`,
    author: "Nick",
    avatar:
      "https://cdn.prod.website-files.com/63ee447a4fee9dcb9b6fd14b/64d0ffe9d6e622388d803c24_Nick%20Fitz.png",
    image: "/img/nick-boston.png",
  },
  "outro",
];

const signoffs = [
  "We'll miss you ❤️",
  "We'll miss you for a bit, but that will fade",
  "We'll at least remember that you worked here",
  "Idk, some dude who used to work here I guess",
];

function IntroScroll() {
  // const FadeUp = batch(Fade(), Move(), Sticky());
  // const chartRef = useRef();
  // const chartVisible = useIsVisible(chartRef, { once: false });
  const [signoffIndex, setSignoffIndex] = React.useState(0);
  return (
    <Box bg="black">
      <ScrollContainer>
        {messages.map((message, i) => {
          if (message === "intro")
            return (
              <ScrollPage>
                <Flex h="100vh" w={"100%"} alignItems={"center"}>
                  <Box
                    height={{ base: "400px", md: "100vh" }}
                    bgImage={"/team.png"}
                    bgSize={"cover"}
                    bgPos={"center center"}
                    w={"100%"}
                  />
                </Flex>
              </ScrollPage>
            );
          if (message === "outro")
            return (
              <ScrollPage>
                <Center height={"100%"}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={"30px"}
                    px={8}
                    color={"white"}
                    mt={-8}
                    onClick={() =>
                      setSignoffIndex((signoffIndex + 1) % signoffs.length)
                    }
                    opacity={1 - signoffIndex * 0.25}
                  >
                    {signoffs[signoffIndex]}
                  </Text>
                </Center>
              </ScrollPage>
            );
          return (
            <ScrollPage>
              <Stack
                gap={0}
                flex={1}
                justifyContent={{ base: "center", md: "center" }}
                alignItems={"center"}
                h={"100vh"}
                w={"100%"}
                maxW={"90vw"}
                mx={{ base: 4, md: 0 }}
              >
                <Flex
                  flexDir={{ base: "column", md: "row" }}
                  justifyContent={{ base: "flex-start", md: "center" }}
                  alignItems={{ base: "center", md: "flex-start" }}
                >
                  <Animator animation={batch(ZoomIn(0, 1))}>
                    <Avatar
                      mb={{ base: 4, md: 6 }}
                      width={{ base: "80px", md: "160px" }}
                      height={{ base: "80px", md: "160px" }}
                      src={message.avatar}
                    />
                  </Animator>
                  <Animator
                    animation={batch(
                      MoveIn(i % 2 ? SHIFT_AMOUNT : SHIFT_AMOUNT, 0)
                      // FadeOut(1, -1)
                      // MoveOut(i % 2 ? -100 : 100, 0)
                    )}
                  >
                    {message.message.split("\n").map((snippet) => (
                      <Text
                        // textAlign={{ base: "center" }}
                        fontSize={{ base: "15px", md: "20px" }}
                        mb={4}
                        lineHeight={"1.2"}
                        color="white"
                        w={"100%"}
                        maxW={680}
                        minW={360}
                        px={4}
                        textShadow={"0 0 10px rgba(0,0,0,0.5)"}
                      >
                        {snippet.trim()}
                      </Text>
                    ))}

                    {message.image && (
                      <Animator
                        animation={batch(
                          MoveIn(-1000, 0)
                          // ZoomIn(-1, 1),
                          // MoveOut(i % 2 ? 100 : -100, 0),
                          // ZoomOut(1, 2)
                        )}
                      >
                        <Box
                          display={"flex"}
                          flexDir={"column"}
                          justifyContent={"space-between"}
                          px={4}
                          // bgColor={"black"}
                          // bgSize={"cover"}
                        >
                          <Image
                            mx={"auto"}
                            w={"100%"}
                            maxW={680}
                            mt={2}
                            src={message.image}
                          />
                        </Box>
                      </Animator>
                    )}
                  </Animator>
                </Flex>
              </Stack>
            </ScrollPage>
          );
        })}
      </ScrollContainer>
    </Box>
  );
}
export default IntroScroll;
